import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import SearchBar from "material-ui-search-bar";

function descendingComparator(a, b, orderBy) {
    if (a[orderBy] === null || a[orderBy] === '') {
        return 1;
    }
    else if (b[orderBy] === null || b[orderBy] === '') {
        return -1;
    }
    if (orderBy === 'displaySiteDNS' || orderBy === 'displaySiteName') { 
        return a[orderBy].toLowerCase().localeCompare(b[orderBy].toLowerCase());
    }
    else if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    else if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}
function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}
const headCells = [
    { id: 'siteId', label: 'Site ID' },
    { id: 'changedDate', label: 'Date' },
    { id: 'displaySiteDNS', label: 'DNS Site Code' },
    { id: 'displaySiteName', label: 'Site Name' },
    { id: 'displayType', label: 'Type' },
    { id: 'displayAction', label: 'Action' },
    { id: 'displayChangedByName', label: 'Changed By' }
];
function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, handleSearch, handleCancelSearch } = props;
    const [searchedDNS, setSearchedDNS] = useState("");
    const [searchedName, setSearchedName] = useState("");
    const [searchedType, setSearchedType] = useState("Action");
    const [searchedAction, setSearchedAction] = useState("Action");

    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    const searchHandler = (searchVal, domain) => {
        handleSearch(searchVal, domain);
        if (domain == 'displaySiteDNS') {
            setSearchedName('');
            setSearchedType(' Type ');
            setSearchedAction(' Action ');
            setSearchedDNS(searchVal);
        }
        if (domain == 'displaySiteName') {
            setSearchedDNS('');
            setSearchedType(' Type ');
            setSearchedAction(' Action ');
            setSearchedName(searchVal);
        }
        if (domain == 'displayType') {
            setSearchedDNS('');
            setSearchedName('');
            setSearchedAction(' Action ');
            setSearchedType(searchVal)
        }
        if (domain == 'displayAction') {
            setSearchedDNS('');
            setSearchedName('');
            setSearchedType(' Type ');
            setSearchedAction(searchVal)
        }
    }
    return (
        <TableHead>
            <TableRow>
                <TableCell />
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align='center'
                        paddingBottom='50px'
                        style={{ fontSize: '1vw', padding: '5px' }}
                        
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <div class="input-group" style={{ justifyContent: 'center', marginBottom: '8px', minWidth: '193px' }}>
                            {headCell.id === "displaySiteDNS" &&
                                <SearchBar
                                    placeholder="DNS Site Code"
                                    value={searchedDNS}
                                    onChange={(searchVal) => searchHandler(searchVal, "displaySiteDNS")}
                                    onCancelSearch={() => handleCancelSearch()}
                                    className={classes.searchbar}
                                    style={{ width: '80%' }}
                                />
                            }
                            {headCell.id === "displaySiteName" &&
                                <SearchBar
                                    placeholder="Site Name"
                                    value={searchedName}
                                    onChange={(searchVal) => searchHandler(searchVal, "displaySiteName")}
                                    onCancelSearch={() => handleCancelSearch()}
                                    className={classes.searchbar}
                                    style={{ width: '80%' }}
                                />
                            }

                            {(headCell.id != "displayType" && headCell.id != "displayAction") &&
                                <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                                >
                                {(headCell.id == "displayChangedByName" || headCell.id == "siteId" || headCell.id == "changedDate") &&
                                        <div align='center' style={{ fontSize: '.9vw' }} >
                                            {headCell.label}
                                        </div>
                                    }

                                    {orderBy === headCell.id ? (
                                        <span className={classes.visuallyHidden}>
                                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                        </span>
                                    ) : null}
                                </TableSortLabel>
                                }
                        </div>

                        {headCell.id === "displayType" &&
                            <select value={searchedType} class="form-control" type="text" name="displayType"
                                style={{ width: '125px', height: '40px', fontSize: '.75vw', margin: 'auto', marginBottom: '12px' }}
                                onChange={(v) => searchHandler(v.target.value.toString(), "displayType")}>
                                <option value="" > Type </option>
                                <option value="Primary">Primary</option>
                                <option value="Secondary">Secondary</option>
                            </select>
                        }
                        {headCell.id === "displayAction" &&
                            <select value={searchedAction} class="form-control" type="text" name="displayAction"
                                style={{ width: '125px', height: '40px', fontSize: '.75vw', margin: 'auto', marginBottom: '12px' }}
                                onChange={(v) => searchHandler(v.target.value.toString(), "displayAction")}>
                                <option value="" > Action </option>
                                <option value="Insert">Insert</option>
                                <option value="Update">Update</option>
                                <option value="Delete">Delete</option>
                            </select>
                        }
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1)
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85)
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark
            },
    title: {
        flex: '1 1 100%',
        margin : 40
    }
}));

const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const { numSelected } = props;
    return (
        <Toolbar
            className={clsx(classes.root, {
                [classes.highlight]: numSelected > 0
            })}
        >
            <Typography className={classes.title} variant="h5" id="tableTitle" component="div">
                Site Audit
            </Typography>
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 950,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    },
    searchbar: {
        width: '93%',
        height: '40px'
    },
    firstCell: {
        width: '10%',
        minWidth: '20px'
    },
    subTable: {
        "& td": {
            width: '33%',
            borderLeft: '1px solid rgba(224, 224, 224, 1)'            
        }
    }
}));

const getDateFormat = (date) => {
    if (date == null) return
    var newDate = date.split('T')[0];
    var dateArray = newDate.split('-');
    var year = dateArray[0].substring(2);
    var month = dateArray[1];
    var day = dateArray[2];
    var fullTime = date.split('T')[1].split('.')[0];
    var hour = fullTime.substring(0, 2);
    var finalTime;
    if (parseInt(hour) > 12) {
        if (parseInt(hour) > 21) {
            finalTime = (hour - 12) + fullTime.substring(2, 5);
        } else {
            finalTime = "0" + (hour - 12) + fullTime.substring(2, 5);
        }
        finalTime += " PM"
    } else {
        finalTime = hour + fullTime.substring(2, 5);
        finalTime += " AM"
    }
    var myDate = `${month}/${day}/${year} - ${finalTime}`
    return myDate;
}

function CollapsedRows(props) {
    const { row, index, classes } = props;
    const [open, setOpen] = React.useState(false);

    return (
        <React.Fragment>
            <TableRow style={{ backgroundColor: index % 2 ? "#f8f8f8" : "white", height: '80px' }}>
                <TableCell class="firstCell">
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell align="center" style={{ borderBottom: 'none' }}>{row.siteId}</TableCell>
                <TableCell align="left" style={{ minWidth: '206px', borderBottom: 'none' }}>{getDateFormat(row.changedDate)}</TableCell>
                <TableCell align="center" style={{ borderBottom: 'none' }}>{row.displaySiteDNS}</TableCell>
                <TableCell align="center" style={{ borderBottom: 'none' }}>{row.displaySiteName}</TableCell>
                <TableCell align="center" style={{ borderBottom: 'none' }}>{row.displayType}</TableCell>
                <TableCell align="center" style={{ borderBottom: 'none' }}>{row.displayAction}</TableCell>
                <TableCell align="center" style={{ borderBottom: 'none' }}>{row.displayChangedByName}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8} >
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="h6" gutterBottom component="div">
                                Changes Made
                            </Typography>
                            <Table size="small" aria-label="purchases" >
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Details</TableCell>
                                        <TableCell>Before</TableCell>
                                        <TableCell>After</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody className={classes.subTable}>
                                    <TableRow style={{ background: '#F8F8F8' }}>
                                        <TableCell style={{ borderLeft: 'none' }}>Site ID</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.beforeSiteId}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.beforeSiteId != null && row.beforeSiteId != row.afterSiteId ? 'bold' : 'normal'
                                            }}>
                                            {row.afterSiteId}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ borderLeft: 'none' }}>Site Name</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.beforeSiteName}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.beforeSiteName != null && row.beforeSiteName != row.afterSiteName ? 'bold' : 'normal'
                                            }}>
                                            {row.afterSiteName}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow style={{ background: '#F8F8F8' }}>
                                        <TableCell style={{ borderLeft: 'none' }}>DNS Site Code</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.beforeSiteDNS}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.beforeSiteDNS != null && row.beforeSiteDNS != row.afterSiteDNS ? 'bold' : 'normal'
                                            }}>
                                            {row.afterSiteDNS}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell style={{ borderLeft: 'none' }}>Country</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.beforeSiteCountry}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.beforeSiteCountry != null && row.beforeSiteCountry != row.afterSiteCountry ? 'bold' : 'normal'
                                            }}>
                                            {row.afterSiteCountry}
                                        </TableCell>
                                    </TableRow>


                                    <TableRow style={{ background: '#F8F8F8' }}>
                                        <TableCell style={{ borderLeft: 'none' }}>State</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.beforeSiteState}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.beforeSiteState != null && row.beforeSiteState != row.afterSiteState ? 'bold' : 'normal'
                                            }}>
                                            {row.afterSiteState}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ borderLeft: 'none' }}>City</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.beforeSiteCity}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.beforeSiteCity != null && row.beforeSiteCity != row.afterSiteCity ? 'bold' : 'normal'
                                            }}>
                                            {row.afterSiteCity}
                                        </TableCell>
                                    </TableRow>
                                    {row.displayType == "Primary" &&
                                        <>
                                        <TableRow style={{ background: '#F8F8F8' }}>
                                            <TableCell style={{ borderLeft: 'none' }}>Dial Plan</TableCell>
                                            <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.beforeSitDialPlan}</TableCell>
                                            <TableCell
                                                style={{
                                                    borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                    fontWeight: row.beforeSitDialPlan != null && row.beforeSitDialPlan != row.afterSitDialPlan ? 'bold' : 'normal'
                                                }}>
                                                {row.afterSitDialPlan}
                                            </TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell style={{ borderLeft: 'none' }}>Voice Policy</TableCell>
                                            <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.beforeSiteVoicePolicy}</TableCell>
                                            <TableCell
                                                style={{
                                                    borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                    fontWeight: row.beforeSiteVoicePolicy != null && row.beforeSiteVoicePolicy != row.afterSiteVoicePolicy ? 'bold' : 'normal'
                                                }}>
                                                {row.afterSiteVoicePolicy}
                                            </TableCell>
                                        </TableRow>

                                        </>
                                    }
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}
const SiteAuditTable = ({ data: siteAudits }) => {
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [searched, setSearched] = useState("");

    const getSites = () => {
        return siteAudits.map(site => {
            if (site.action == 'Delete') {
                return {
                    siteId: site.siteId,
                    changedDate: site.changedDate,
                    displaySiteDNS: site.dnsSiteCode,
                    displaySiteName: site.siteName,
                    displayChangedBy: site.changedBy,
                    displayType: site.type,
                    displayAction: site.action,
                    displayChangedBy: site.changedBy,
                    displayChangedByName: site.changedByName == null ? site.changedBy : site.changedByName,
                    beforeSiteId: site.siteId,
                    beforeSiteName: site.siteName,
                    beforeSiteDNS: site.dnsSiteCode,
                    beforeSiteCountry: site.country,
                    beforeSiteState: site.state,
                    beforeSiteCity: site.city,
                    beforeSitDialPlan: site.dialPlan,
                    beforeSiteVoicePolicy: site.voicePolicy,
                    afterSiteId: null,
                    afterSiteName: null,
                    afterSiteDNS: null,
                    afterSiteCountry: null,
                    afterSiteState: null,
                    afterSiteCity: null,
                    afterSitDialPlan: null,
                    afterSiteVoicePolicy: null,
                    afterSitDialPlan: null,
                    afterSiteVoicePolicy: null
                }
            }
            if (site.action == 'Insert') {
                return {
                    siteId: site.siteId,
                    changedDate: site.changedDate,
                    displaySiteDNS: site.newDnsSiteCode,
                    displaySiteName: site.newSiteName,
                    displayType: site.type,
                    displayAction: site.action,
                    displayChangedBy: site.changedBy,
                    displayChangedByName: site.changedByName == null ? site.changedBy : site.changedByName,
                    beforeSiteId: null,
                    beforeSiteName: null,
                    beforeSiteDNS: null,
                    beforeSiteCountry: null,
                    beforeSiteState: null,
                    beforeSiteCity: null,
                    beforeSitDialPlan: null,
                    beforeSiteVoicePolicy: null,
                    afterSiteId: site.siteId,
                    afterSiteName: site.newSiteName,
                    afterSiteDNS: site.newDnsSiteCode,
                    afterSiteCountry: site.newCountry,
                    afterSiteState: site.newState,
                    afterSiteCity: site.newCity,
                    afterSitDialPlan: site.newDialPlan,
                    afterSiteVoicePolicy: site.newVoicePolicy
                }
            }
            if (site.action == 'Update') {
                return {
                    siteId: site.siteId,
                    changedDate: site.changedDate,
                    displaySiteDNS: site.newDnsSiteCode,
                    displaySiteName: site.newSiteName,
                    displayType: site.type,
                    displayAction: site.action,
                    displayChangedBy: site.changedBy,
                    displayChangedByName: site.changedByName == null ? site.changedBy : site.changedByName, 
                    beforeSiteId: site.siteId,
                    beforeSiteName: site.siteName,
                    beforeSiteDNS: site.dnsSiteCode,
                    beforeSiteCountry: site.country,
                    beforeSiteState: site.state,
                    beforeSiteCity: site.city,
                    beforeSitDialPlan: site.dialPlan,
                    beforeSiteVoicePolicy: site.voicePolicy,
                    afterSiteId: site.siteId,
                    afterSiteName: site.newSiteName,
                    afterSiteDNS: site.newDnsSiteCode,
                    afterSiteCountry: site.newCountry,
                    afterSiteState: site.newState,
                    afterSiteCity: site.newCity,
                    afterSitDialPlan: site.newDialPlan,
                    afterSiteVoicePolicy: site.newVoicePolicy
                }
            }
        })
    }

    const [rows, setRows] = useState(getSites());

    const requestSearch = (searchedVal, domain) => {
        setPage(0);
        const filteredRows = getSites().filter((row) => {
            if (domain === "displaySiteDNS") {
                if (row.displaySiteDNS !== null) return row.displaySiteDNS.toString().toLowerCase().includes(searchedVal.toLowerCase());
                else return null;
            }
            if (domain === "displaySiteName") {
                if (row.displaySiteName !== null) return row.displaySiteName.toString().toLowerCase().includes(searchedVal.toLowerCase());
                else return null;
            }
            if (domain === "displayType") {
                if (row.displayType !== null) return row.displayType.toString().toLowerCase().includes(searchedVal.toLowerCase());
                else return null;
            }
            if (domain === "displayAction") {
                if (row.displayAction !== null) return row.displayAction.toString().toLowerCase().includes(searchedVal.toLowerCase());
                else return null;
            }
            return getSites()
        });
        return setRows(filteredRows);
    };

    const cancelSearch = () => {
        setSearched("");
        requestSearch(searched, "siteName"); // Domain set to anything will work here, without cancel will break as none of the request search options will be hit!
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <EnhancedTableToolbar />
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={'medium'}
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                            handleSearch={requestSearch}
                            handleCancelSearch={cancelSearch}
                            searched={searched}

                        />
                        <TableBody>
                            {stableSort(rows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    return (
                                        <CollapsedRows
                                            classes={classes}
                                            index={index}
                                            row={row}
                                        />
                                    );
                                })}
                            {(emptyRows > 0 && rows.length >= rowsPerPage) && (
                                <TableRow style={{ height: 80 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangeRowsPerPage={handleChangeRowsPerPage} // Material v < 4
                    onRowsPerPageChange={handleChangeRowsPerPage} // Material v > 4 
                    onPageChange={handleChangePage} // Material v > 4
                    onChangePage={handleChangePage} // Material v < 4 
                />
            </Paper>
        </div>
    );
}

export default SiteAuditTable;
